<template>
  <div>
  </div>
</template>
<script>
  export default {
    name: 'PaymentYapayCallback',
    methods: {
      showLoader () {
        this.$loader.show()
      },
      redirectToBalanceConfirm () {
        const subdomain = window.sessionStorage.getItem('subdomain')
        const identifier = window.sessionStorage.getItem('identifier')
        const url = process.env.URL_SELLER.replace('%s', subdomain) + '/payment/invoice/' + identifier + '/balance/confirm/' + this.$route.params.token
        window.location.href = url
      }
    },
    mounted () {
      this.showLoader()
      this.redirectToBalanceConfirm()
    }
  }
</script>


// WEBPACK FOOTER //
// PaymentYapayCallback.vue?bf7e4a68